// Delt bildehåndtering for tilbud (/t/) og kundeportaler (/p/).

// Skalerer ned store bilder før opplasting. Bevisst mild: maks 2560px og
// kvalitet 0.92, så bildene fortsatt er skarpe på store skjermer. PNG beholdes
// som PNG (gjennomsiktighet), og fila røres ikke om den ikke blir mindre.
const MAX_DIM = 2560, JPEG_QUALITY = 0.92, COMPRESS_OVER = 1.5*1024*1024;

export const EXT_BY_TYPE = { "image/jpeg":"jpg", "image/png":"png", "image/webp":"webp" };

export async function compressImage(file){
  if(!file || !(file.type||"").startsWith("image/")) return file;
  if(/svg|gif/.test(file.type)) return file;                     // vektor/animasjon: la stå
  const bitmap = await createImageBitmap(file).catch(()=>null);
  if(!bitmap) return file;                                        // f.eks. HEIC: last opp som den er
  const { width:w, height:h } = bitmap;
  const scale = Math.min(1, MAX_DIM/Math.max(w,h));
  if(scale===1 && file.size<=COMPRESS_OVER){ bitmap.close?.(); return file; }
  const canvas = document.createElement("canvas");
  canvas.width = Math.round(w*scale); canvas.height = Math.round(h*scale);
  canvas.getContext("2d").drawImage(bitmap, 0, 0, canvas.width, canvas.height);
  bitmap.close?.();
  const isPng = file.type==="image/png";
  const blob = await new Promise(r=>canvas.toBlob(r, isPng?"image/png":"image/jpeg", isPng?undefined:JPEG_QUALITY));
  if(!blob || blob.size>=file.size) return file;
  return new File([blob], file.name, { type:blob.type });
}

// Kopierer en fil som ligger i et ANNET tilbud/portal sin mappe inn i vår egen,
// og returnerer den nye URL-en. Uten dette peker et duplikat på originalens
// filer, og mister bildene hvis originalen slettes.
// urlPrefix er "t" eller "p"; dir(slug) gir mappen i bucketen.
export function makeAdoptUrl({ storage, bucket, slug, urlPrefix, dir, token }){
  const cache = new Map();
  return async (url) => {
    const m = new RegExp(`^/${urlPrefix}/([a-z0-9-]+)/assets/([^/?#]+)$`).exec(url||"");
    if(!m || m[1]===slug) return url||"";            // eget bilde, tomt eller ekstern URL
    if(cache.has(url)) return cache.get(url);
    const ext=(m[2].split('.').pop()||'jpg').toLowerCase().replace(/[^a-z0-9]/g,'');
    const dest=`${dir(slug)}/assets/${token(6)}.${ext}`;
    const { error } = await storage.from(bucket).copy(`${dir(m[1])}/assets/${m[2]}`, dest);
    const next = error ? url : `/${urlPrefix}/${slug}/assets/${dest.split('/').pop()}`;  // mangler kilden: behold
    cache.set(url, next);
    return next;
  };
}
